const UML_SELECTOR = '.rich-text-content .uml-diagram';
const EDITOR_SELECTOR = '[data-component="textarea-editor"]';
const DARK_MODE_PREFIX = '#background: #1f2937\n#fill: #374151\n#stroke: #9ca3af\n#.box: visual=roundrect fill=#374151 stroke=#8b5cf6\n';

function isInsideEditor(element) {
    return Boolean(element?.closest?.(EDITOR_SELECTOR));
}

function decodeUmlSource(encodedValue) {
    if (!encodedValue) {
        return '';
    }

    try {
        return normalizeUmlSource(decodeURIComponent(escape(window.atob(encodedValue))));
    } catch (error) {
        return normalizeUmlSource(encodedValue);
    }
}

function normalizeUmlSource(value) {
    if (typeof value !== 'string') {
        return '';
    }

    return value
        .replace(/\r\n?/g, '\n')
        .replace(/\\n/g, '\n')
        .trim();
}

function buildDiagramCode(umlSource) {
    if (document.body.getAttribute('data-bs-theme') === 'dark') {
        return DARK_MODE_PREFIX + umlSource;
    }

    return umlSource;
}

let nomnomlPromise = null;

function getNomnoml() {
    if (!nomnomlPromise) {
        nomnomlPromise = import('../vendor/nomnoml.js');
    }
    return nomnomlPromise;
}

function renderDiagram(element) {
    if (!element || isInsideEditor(element)) {
        return;
    }

    const umlSource = decodeUmlSource(element.getAttribute('data-uml'));
    if (!umlSource) {
        return;
    }

    getNomnoml().then((nomnoml) => {
        try {
            element.innerHTML = '';
            element.classList.add('uml-rendered');

            const canvas = document.createElement('canvas');
            element.appendChild(canvas);
            nomnoml.draw(canvas, buildDiagramCode(umlSource));
        } catch (error) {
            console.error('Error rendering UML diagram:', error);
            element.innerHTML = '<div class="tw-rounded-lg tw-border tw-border-danger/30 tw-bg-danger/10 tw-p-3 tw-text-sm tw-text-danger">Błąd renderowania diagramu UML: ' + error.message + '</div>';
        }
    });
}

function renderUmlDiagrams(root = document) {
    const nodes = [];
    if (root.matches?.(UML_SELECTOR)) {
        nodes.push(root);
    }

    root.querySelectorAll?.(UML_SELECTOR).forEach((node) => {
        nodes.push(node);
    });

    nodes.forEach((node) => {
        renderDiagram(node);
    });
}

function initUmlDiagrams() {
    renderUmlDiagrams(document);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== Node.ELEMENT_NODE || isInsideEditor(node)) {
                    return;
                }

                renderUmlDiagrams(node);
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUmlDiagrams, { once: true });
} else {
    initUmlDiagrams();
}
